import { Col, Row } from "react-bootstrap";
import React from "react";
import { useSelector } from "react-redux";
import KnowledgeBottom from "./ResultBottom/KnowledgeBottom";

export default function KnowledgeResult() {
  const knowledgeResult = useSelector(
    (state) => state.statehome.knowledgeResult
  );
  const innovationsResult = useSelector(
    (state) => state.statehome.innovationsResult
  );

  return (
    <Row>
      {knowledgeResult.length ? (
        <Col sm={12} md={12}>
          <div
            className="card-university"
            style={{
              backgroundColor: "#fff",
              borderRadius: "15px",
            }}
          >
            <div className="card-header">
              <h5>องค์ความรู้เดิม</h5>
              <p>จำนวน {knowledgeResult.length}</p>
            </div>
            <div className="card-university-body">
              <div className="list">
                {knowledgeResult.map((data, index) => (
                  <div className="detail" key={index}>
                    <h5>{data.title}</h5>
                    <p>
                      รายละเอียด :{" "}
                      {data.detail.replace(/<[^>]+>|&nbsp;|&quot;/g, "")}
                    </p>
                    <hr className="line-researcher" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Col>
      ) : (
        <KnowledgeBottom />
      )}

      {innovationsResult.length ? (
        <Col sm={12} md={12}>
          <div
            className="card-university"
            style={{
              backgroundColor: "#fff",
              borderRadius: "15px",
            }}
          >
            <div className="card-header">
              <h5>นวัตกรรม</h5>
              <p>จำนวน {innovationsResult.length}</p>
            </div>
            <div className="card-university-body">
              <div className="list">
                {innovationsResult.map((data, index) => (
                  <div className="detail" key={index}>
                    <h5>{data.title}</h5>
                    <p>
                      รายละเอียด :{" "}
                      {data.detail.replace(/<[^>]+>|&nbsp;|&quot;/g, "")}
                    </p>
                    <hr className="line-researcher" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Col>
      ) : (
        <KnowledgeBottom />
      )}
    </Row>
  );
}
